import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import translate from '../../libs/i18n';
import { notificationShape } from '../../utils/propTypesShapes';

import { NotificatioItemStyle } from './NotificationItemStyle';

const NotificationItem = ({ notification, handleViewNotification }) => {
  const language = useSelector((state) => state.settings.language);

  const truncate = (text, maxLength) => {
    if (!text) return '';
    return text.length > maxLength ? `${text.substring(0, maxLength)}…` : text;
  };


  return (
<>
  <NotificatioItemStyle
    type="button"
    onClick={() =>
      handleViewNotification(notification.id, notification.url)
    }
  >
    <div className="notification-info">
      {(() => {
        const msg = language === 'pt-br'
          ? notification.message
          : notification.message_en;

        const parts = msg.split('. ');
        const mainMessage = (parts[0] || '') + '.';

        const info = parts[1] || '';

        const patientKey = language === 'pt-br' ? 'Paciente:' : 'Patient:';
        const seriesKey  = language === 'pt-br' ? 'Série:'    : 'Series:';

        const afterPatient = info.split(patientKey)[1] || '';

        const [patientValueRaw, seriesValueRaw] = afterPatient.split(seriesKey);

        const patientMessage = `${patientKey} ${patientValueRaw.trim()}`;
        const seriesMessage  = `${seriesKey} ${seriesValueRaw.trim()}`;
        
        return (
          <>
            <span className="exam-main-message">{truncate(mainMessage, 30)}</span>
            <span className="exam-patient-message">{truncate(patientMessage, 30)}</span>
            <span className="exam-series-message">{truncate(seriesMessage, 30)}</span>
          </>
        );
      })()}
    </div>
    
    <div className="notification-right-column">
      <div className="notification-date-time-wrapper">
        <span className="date">{new Date(notification.date).toLocaleDateString(language)}</span>
        <span className="time">
          {new Date(notification.date).toLocaleTimeString(language, {
            hour: '2-digit',
            minute: '2-digit'
          })}
        </span>
      </div>
      <span
        className={
          notification.viewed ? 'notification-viewed' : 'notification-status'
        }
      >
        {notification.viewed
          ? translate('notificationViewed', language)
          : translate('notificationNotViewed', language)}
      </span>
    </div>
  </NotificatioItemStyle>
</>
  );
};

NotificationItem.propTypes = {
  notification: notificationShape.isRequired,
  handleViewNotification: PropTypes.func.isRequired,
};

export default NotificationItem;
